<div *ngIf="from && to && message" class="banner-maintenance">
  <span [innerHTML]="formattedMessage"></span>
</div>
